
var timelineSlider = $('.timeline__slider');

timelineSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('#milestone-' + $(slick.$slides.get(currentSlide)).find('.milestone-image').attr('data-key')).attr('style', 'display: none;');
    $('#milestone-' + $(slick.$slides.get(nextSlide)).find('.milestone-image').attr('data-key')).attr('style', 'display: inline-block;');
});
